module.exports = "<div id=\"snackbar\" class=\"w3-card-4 w3-block w3-black w3-display-container\" \r\n\t(click)=\"onCloseAlert($event)\" [ngClass]=\"alertClass\">\r\n\t\r\n\t<h5><i [ngClass]=\"alert.iconClass\"></i> {{alert.message}}</h5>\r\n\r\n\t<button id=\"close-btn\" class=\"w3-display-topright w3-button w3-text-red w3-hover-black\">\r\n\t\t<i class=\"fa fa-times\"></i>\r\n\t</button>\r\n</div>"


//////////////////
// WEBPACK FOOTER
// ./src/app/components/shared/snack-bar/snack-bar.component.html
// module id = ./src/app/components/shared/snack-bar/snack-bar.component.html
// module chunks = main